module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"container-slim section-margin\"> <h3>Please review and confirm your subscription:</h3> <table class=\"table\"> <tr> <td> ")
    ; __append(escapeFn( locals.planQuantity ))
    ; __append(" ")
    ; __append(escapeFn( locals.planName ))
    ; __append(" Lookups/")
    ; __append(escapeFn( locals.planInterval ))
    ; __append(" </td> <td> $")
    ; __append(escapeFn( locals.planPrice ))
    ; __append("/")
    ; __append(escapeFn( locals.planInterval ))
    ; __append(" </td> </tr> <tr> <td class=\"bold text-red\"> Total due now </td> <td class=\"bold text-red\"> $")
    ; __append(escapeFn( locals.planPrice ))
    ; __append(" </td> </tr> </table> <p>If you have a primary payment method on your account, your next payment of ")
    ; __append(escapeFn( locals.nextPaymentAmount ))
    ; __append(" will be automatically deducted on <strong>")
    ; __append(escapeFn( locals.nextPaymentDate ))
    ; __append(" </strong> from that payment method on file. If you do not have a primary method on your account, you can add that information from your dashboard to keep your subscription active.</p> <button class=\"btn btn-blue\" type=\"button\" id=\"confirm-purchase\" data-plan=\"")
    ; __append(escapeFn( locals.plan ))
    ; __append("\">Confirm Subscription</button> <p class=\"text-sm\">By subscribing to EasyPost you agree to the <a href=\"/privacy.html\" target=\"_blank\">terms and conditions</a>. </p></div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/purchase-confirmation.ejs
// module id = 902
// module chunks = 1